// extracted by css-extract-rspack-plugin
export default {"dangerItem":"osFsH"};